const MODES_REQUIRING_LOCATION = new Set(["Centre visit"]);

export function modeRequiresLocation(modeName) {
  return MODES_REQUIRING_LOCATION.has(modeName);
}
